import { Route, Routes } from "react-router-dom";
import { IndexPage } from "./pages/TrackingPartners";


export function TrackingPartnerManagementRoutes() {
	return (
		<Routes>
			<Route index element={<IndexPage />} />
		</Routes>
	);
}